import { createAction, props } from '@ngrx/store';

const REQUEST_AUTH_LOGOUT = '[Auth][Request] Auth Logout';
const RESPONSE_SUCCESS_AUTH_LOGOUT = '[Auth][Response][Success] Auth Logout';
export const RESPONSE_FAIL_AUTH_LOGOUT = '[Auth][Response][Fail] Auth Logout';
export const FORCE_LOGOUT_401 = '[Auth] Force Logout 401';

export const RequestAuthLogoutAction = createAction(
  REQUEST_AUTH_LOGOUT,
  props<{ stayOnCurrentRoute?: boolean }>()
);
export const ResponseSuccessAuthLogoutAction = createAction(
  RESPONSE_SUCCESS_AUTH_LOGOUT,
  props<{ stayOnCurrentRoute?: boolean }>()
);

export const ResponseFailAuthLogoutAction = createAction(
  RESPONSE_FAIL_AUTH_LOGOUT,
  props<{ payload: any }>()
);
export const ForceLogout401 = createAction(FORCE_LOGOUT_401, props<{ payload?: string }>());
